<div #pdfContent *ngIf="report" class="print-container content">
    <div class="padding-left-box">
        <div class="shadow-header font-header">
            <span *ngIf="level === 'learner'">New 1 to 1 - Meeting Agenda<span *ngIf="report.id > 0"> - {{report.created_at | amDateFormat : 'DD / MM / YY'}}</span></span>
            <span *ngIf="level === 'manager'">{{report.delegate.full_name}} <span style="font-weight: normal;">{{ "__REVIEW_MEETING_AGENDA__" | translate }}</span><span *ngIf="report.id > 0"> - {{report.created_at | amDateFormat : 'DD / MM / YY'}}</span></span>
            <div style="border-bottom: 2px solid #8dc63f; width: 70%;"></div>
        </div>

        <div class="font-header2">{{ "__REVIEW_PRE-MEETING_QUESTIONNAIRE__" | translate }}</div>
        <div class="questionnaire-block">
            <div class="questionnaire-title">{{ "__REVIEW_PRE-MEETING_QUESTION_1__" | translate }}</div>
            <div class="questionnaire-description">{{ "__REVIEW_PRE-MEETING_DESCRIPTION_1__" | translate }}</div>
        </div>
        <div class="questionnaire-block">
            <div class="questionnaire-title">{{ "__REVIEW_PRE-MEETING_QUESTION_2__" | translate }}</div>
            <div class="questionnaire-description">{{ "__REVIEW_PRE-MEETING_DESCRIPTION_2__" | translate }}</div>
        </div>
        <div class="questionnaire-block">
            <div class="questionnaire-title">{{ "__REVIEW_PRE-MEETING_QUESTION_3__" | translate }}</div>
            <div class="questionnaire-description">{{ "__REVIEW_PRE-MEETING_DESCRIPTION_3__" | translate }}</div>
        </div>
    </div>
    <div class="feedback-element">
        <div class="dropdown-content">
            <app-questionnaire-text
                *ngFor="let answer of report.answers_one2one.value"
                [title]="answer.question.title"
                [hint]="answer.question.hint"
                [answer]="answer.answer.value"
                class="line-top"
            ></app-questionnaire-text>
        </div>
        <div class="form-actions-wrap">
            <img src="assets/img/{{ report.status.value ? 'tick-large-icon-active.svg' : 'tick-large-icon.svg' }}"
                 alt="Custom Checkbox">
        </div>
    </div>
</div>

